import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, TextField } from '@mui/material';
import { IconSend } from '@tabler/icons-react';

// ==============================|| CHAT INPUT ||============================== //
//
// Enter sends, Shift+Enter inserts a newline (ChatGPT/Claude style).

const MAX_QUESTION_CHARS = 2000;

const ChatInput = ({ onSend, disabled, divider = true }) => {
  const [value, setValue] = useState('');

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <Box sx={{ p: 1.5, ...(divider && { borderTop: '1px solid', borderColor: 'divider' }) }}>
      <TextField
        fullWidth
        multiline
        maxRows={5}
        size="small"
        placeholder="Ask about devices or firmware…"
        value={value}
        onChange={(e) => setValue(e.target.value.slice(0, MAX_QUESTION_CHARS))}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            endAdornment: (
              <IconButton color="primary" onClick={submit} disabled={disabled || !value.trim()} sx={{ alignSelf: 'flex-end' }}>
                <IconSend size={20} />
              </IconButton>
            )
          }
        }}
      />
    </Box>
  );
};

ChatInput.propTypes = {
  onSend: PropTypes.func,
  disabled: PropTypes.bool,
  divider: PropTypes.bool
};

export default ChatInput;
